import {toast} from "react-toastify";

import {BmErrorToast} from "~/components/toasts/ErrorToast/ErrorToast";

export const errorToast = (message: string) => {
  toast(() => <BmErrorToast message={message} />);
};
